var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('drive',{attrs:{"idarchivo":_vm.idarchivo},on:{"idarchivo":function($event){_vm.idarchivo=$event}}}),_vm._v(" "+_vm._s(_vm.idarchivo)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }